var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowPrices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4569_409",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 94,
    height: 95
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.770874H94V94.7709H0V0.770874Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4569_409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9971 88.89C74.4157 88.89 88.1191 70.4777 88.1191 47.765C88.1191 25.0581 74.4157 6.64587 46.9941 6.64587C19.5784 6.64587 5.875 25.0581 5.875 47.7679C5.875 70.4777 19.5755 88.89 46.9971 88.89Z",
    fill: "url(#paint0_radial_4569_409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9971 88.89C74.4157 88.89 88.1191 70.4777 88.1191 47.765C88.1191 25.0581 74.4157 6.64587 46.9941 6.64587C19.5784 6.64587 5.875 25.0581 5.875 47.7679C5.875 70.4777 19.5755 88.89 46.9971 88.89Z",
    fill: "url(#paint1_radial_4569_409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9971 88.89C74.4157 88.89 88.1191 70.4777 88.1191 47.765C88.1191 25.0581 74.4157 6.64587 46.9941 6.64587C19.5784 6.64587 5.875 25.0581 5.875 47.7679C5.875 70.4777 19.5755 88.89 46.9971 88.89Z",
    fill: "url(#paint2_radial_4569_409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9971 88.89C74.4157 88.89 88.1191 70.4777 88.1191 47.765C88.1191 25.0581 74.4157 6.64587 46.9941 6.64587C19.5784 6.64587 5.875 25.0581 5.875 47.7679C5.875 70.4777 19.5755 88.89 46.9971 88.89Z",
    fill: "url(#paint3_radial_4569_409)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9971 88.89C74.4157 88.89 88.1191 70.4777 88.1191 47.765C88.1191 25.0581 74.4157 6.64587 46.9941 6.64587C19.5784 6.64587 5.875 25.0581 5.875 47.7679C5.875 70.4777 19.5755 88.89 46.9971 88.89Z",
    fill: "url(#paint4_radial_4569_409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9971 88.89C74.4157 88.89 88.1191 70.4777 88.1191 47.765C88.1191 25.0581 74.4157 6.64587 46.9941 6.64587C19.5784 6.64587 5.875 25.0581 5.875 47.7679C5.875 70.4777 19.5755 88.89 46.9971 88.89Z",
    fill: "url(#paint5_radial_4569_409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9971 88.89C74.4157 88.89 88.1191 70.4777 88.1191 47.765C88.1191 25.0581 74.4157 6.64587 46.9941 6.64587C19.5784 6.64587 5.875 25.0581 5.875 47.7679C5.875 70.4777 19.5755 88.89 46.9971 88.89Z",
    fill: "url(#paint6_radial_4569_409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9971 88.89C74.4157 88.89 88.1191 70.4777 88.1191 47.765C88.1191 25.0581 74.4157 6.64587 46.9941 6.64587C19.5784 6.64587 5.875 25.0581 5.875 47.7679C5.875 70.4777 19.5755 88.89 46.9971 88.89Z",
    fill: "url(#paint7_radial_4569_409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4375 62.4584C34.5492 62.4584 41.125 55.8826 41.125 47.7709C41.125 39.6592 34.5492 33.0834 26.4375 33.0834C18.3258 33.0834 11.75 39.6592 11.75 47.7709C11.75 55.8826 18.3258 62.4584 26.4375 62.4584Z",
    fill: "url(#paint8_radial_4569_409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2812 62.4584C64.5818 62.4584 70.5 56.5401 70.5 49.2396C70.5 41.9391 64.5818 36.0209 57.2812 36.0209C49.9807 36.0209 44.0625 41.9391 44.0625 49.2396C44.0625 56.5401 49.9807 62.4584 57.2812 62.4584Z",
    fill: "url(#paint9_radial_4569_409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8438 56.5834C34.3496 56.5834 37.7118 55.1907 40.1908 52.7117C42.6698 50.2327 44.0625 46.8705 44.0625 43.3646C44.0625 39.8588 42.6698 36.4966 40.1908 34.0176C37.7118 31.5386 34.3496 30.1459 30.8438 30.1459C27.3379 30.1459 23.9757 31.5386 21.4967 34.0176C19.0177 36.4966 17.625 39.8588 17.625 43.3646C17.625 46.8705 19.0177 50.2327 21.4967 52.7117C23.9757 55.1907 27.3379 56.5834 30.8438 56.5834ZM63.1562 56.5834C66.6621 56.5834 70.0243 55.1907 72.5033 52.7117C74.9823 50.2327 76.375 46.8705 76.375 43.3646C76.375 39.8588 74.9823 36.4966 72.5033 34.0176C70.0243 31.5386 66.6621 30.1459 63.1562 30.1459C59.6504 30.1459 56.2882 31.5386 53.8092 34.0176C51.3302 36.4966 49.9375 39.8588 49.9375 43.3646C49.9375 46.8705 51.3302 50.2327 53.8092 52.7117C56.2882 55.1907 59.6504 56.5834 63.1562 56.5834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.25 50.7084C36.8081 50.7084 38.3025 50.0894 39.4043 48.9876C40.506 47.8858 41.125 46.3915 41.125 44.8334C41.125 43.2752 40.506 41.7809 39.4043 40.6791C38.3025 39.5773 36.8081 38.9584 35.25 38.9584C33.6919 38.9584 32.1975 39.5773 31.0957 40.6791C29.994 41.7809 29.375 43.2752 29.375 44.8334C29.375 46.3915 29.994 47.8858 31.0957 48.9876C32.1975 50.0894 33.6919 50.7084 35.25 50.7084Z",
    fill: "url(#paint10_linear_4569_409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.75 50.7084C60.3081 50.7084 61.8025 50.0894 62.9043 48.9876C64.006 47.8858 64.625 46.3915 64.625 44.8334C64.625 43.2752 64.006 41.7809 62.9043 40.6791C61.8025 39.5773 60.3081 38.9584 58.75 38.9584C57.1919 38.9584 55.6975 39.5773 54.5957 40.6791C53.494 41.7809 52.875 43.2752 52.875 44.8334C52.875 46.3915 53.494 47.8858 54.5957 48.9876C55.6975 50.0894 57.1919 50.7084 58.75 50.7084Z",
    fill: "url(#paint11_linear_4569_409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0938 28.6771C20.0719 25.7396 23.7937 19.8646 30.8438 19.8646",
    stroke: "url(#paint12_linear_4569_409)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9062 28.6771C73.9281 25.7396 70.2063 19.8646 63.1562 19.8646",
    stroke: "url(#paint13_linear_4569_409)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8125 68.3334C55.8125 63.4664 51.867 59.5209 47 59.5209C42.133 59.5209 38.1875 63.4664 38.1875 68.3334V74.2084C38.1875 79.0754 42.133 83.0209 47 83.0209C51.867 83.0209 55.8125 79.0754 55.8125 74.2084V68.3334Z",
    fill: "url(#paint14_radial_4569_409)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6865 65.3959C39.2934 63.6759 40.4189 62.1865 41.9078 61.1329C43.3967 60.0794 45.1757 59.5137 46.9996 59.5137C48.8236 59.5137 50.6026 60.0794 52.0915 61.1329C53.5804 62.1865 54.7059 63.6759 55.3128 65.3959H38.6865Z",
    fill: "url(#paint15_radial_4569_409)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4569_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.9068 27.2071) rotate(132.839) scale(110.166)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4569_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.9028 27.2103) rotate(131.878) scale(114.412)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4569_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.998 37.4888) rotate(101.31) scale(52.4244 67.1457)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4569_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.875 41.8959) rotate(135) scale(120.473)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4569_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.9999 50.7106) rotate(77.692) scale(82.6815)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4569_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.4687 49.2396) rotate(55.713) scale(39.1084 28.3478)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_4569_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.2187 53.6459) rotate(9.86582) scale(34.2883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_4569_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4064 44.8342) rotate(43.971) scale(173.468)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_4569_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.8605 36.3479) rotate(135) scale(28.6182 14.8118)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_4569_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.5625 38.9584) rotate(135) scale(23.887 13.4846)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4569_409",
    x1: 60.5566,
    y1: 38.9584,
    x2: 58.5356,
    y2: 50.7965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4569_409",
    x1: 60.5566,
    y1: 38.9584,
    x2: 58.5356,
    y2: 50.7965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4569_409",
    x1: 20.0719,
    y1: 31.3209,
    x2: 20.0719,
    y2: 26.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#524049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2C42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4569_409",
    x1: 73.9281,
    y1: 31.3209,
    x2: 73.9281,
    y2: 26.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#524049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2C42"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_4569_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47 88.2437) rotate(-90) scale(28.7222 21.5417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F70A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89029C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_4569_409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.8309 69.7618) rotate(-67) scale(11.1625 11.1625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ECCDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D590FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowPrices);
export default __webpack_public_path__ + "static/media/low-prices.a7449a6d633f378fb6be80cd33e6c1c1.svg";
export { ForwardRef as ReactComponent };